export const DEBIT_NOTE_STATUS_PENDING = 'PENDING';
export const DEBIT_NOTE_STATUS_SENT = 'SENT';
export const DEBIT_NOTE_STATUS_PARTIAL_PAID = 'PARTIAL_PAID';
export const DEBIT_NOTE_STATUS_PAID = 'PAID';
export const DEBIT_NOTE_STATUS_FAILED = 'FAILED';
export const DEBIT_NOTE_STATUS_REPLACED = 'REPLACED';
export const DEBIT_NOTE_STATUS_SKIPPED = 'SKIPPED';

export const DEBIT_NOTE_SYNC_LOG_PENDING = 'PENDING';
export const DEBIT_NOTE_SYNC_LOG_SUCCESS = 'SUCCESS';
export const DEBIT_NOTE_SYNC_LOG_FAILED = 'FAILED';
export const DEBIT_NOTE_SYNC_LOG_RETRY = 'RETRY';

export const DEBIT_NOTE_WARNING_ACTIVE = 'DEBIT_NOTE_ACTIVE';

export const DEBIT_NOTE_STATUS = {
  [DEBIT_NOTE_STATUS_PENDING]: { id: DEBIT_NOTE_STATUS_PENDING, name: 'Chờ gửi', color: 'default' },
  [DEBIT_NOTE_STATUS_SENT]: { id: DEBIT_NOTE_STATUS_SENT, name: 'Đã gửi đối tác', color: 'blue' },
  [DEBIT_NOTE_STATUS_PARTIAL_PAID]: { id: DEBIT_NOTE_STATUS_PARTIAL_PAID, name: 'Thanh toán một phần', color: 'orange' },
  [DEBIT_NOTE_STATUS_PAID]: { id: DEBIT_NOTE_STATUS_PAID, name: 'Đã tất toán', color: 'green' },
  [DEBIT_NOTE_STATUS_FAILED]: { id: DEBIT_NOTE_STATUS_FAILED, name: 'Gửi lỗi', color: 'red' },
  [DEBIT_NOTE_STATUS_REPLACED]: { id: DEBIT_NOTE_STATUS_REPLACED, name: 'Bản cũ (đã thay thế)', color: 'lightgray' },
  [DEBIT_NOTE_STATUS_SKIPPED]: { id: DEBIT_NOTE_STATUS_SKIPPED, name: 'Không đồng bộ (nhiều STK)', color: 'default' },
};

export const DEBIT_NOTE_SYNC_LOG_STATUS = {
  [DEBIT_NOTE_SYNC_LOG_SUCCESS]: { id: DEBIT_NOTE_SYNC_LOG_SUCCESS, color: 'green' },
  [DEBIT_NOTE_SYNC_LOG_FAILED]: { id: DEBIT_NOTE_SYNC_LOG_FAILED, color: 'red' },
  [DEBIT_NOTE_SYNC_LOG_RETRY]: { id: DEBIT_NOTE_SYNC_LOG_RETRY, color: 'orange' },
  [DEBIT_NOTE_SYNC_LOG_PENDING]: { id: DEBIT_NOTE_SYNC_LOG_PENDING, color: 'default' },
};
